/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { GetTableFooter } from '../../../_component/tableFooter';
import * as toast from '../../../_store/slice/toast';
import server from '../../../_api/backend';

export function AdminGroupBuying(routeProps: RouteComponentProps) {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [items, setItems] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});
  const [searchCollege, setSearchCollege] = useState<string>('');
  const [searchDept, setSearchDept] = useState<string>('');
  const [searchName, setSearchName] = useState<string>('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const history = useHistory();
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getGroupBuyingList().then(() => {});
  }, [currentPage]);

  let onSearch = false;
  let amountResult = 0;

  // 공동구매 현황 조회 API 호출
  const getGroupBuyingList = async () => {
    if (
      onSearch === false ||
      (searchCollege.length === 0 && searchName.length === 0 && searchDept.length === 0)
    ) {
      await server
        .getGroupBuying(currentPage, 10)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            onSearch = false;
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .searchGroupBuying(
          currentPage,
          10,
          searchName,
          searchCollege,
          searchDept,
          startDate,
          endDate
        )
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // 테이블 헤더
  function createTableHeader() {
    return (
      <div className="table-header">
        <div className="search">
          <div className="input date">
            <label htmlFor="from">기간검색</label>
            <input
              type="text"
              id="from"
              name="from"
              placeholder="2021-01-01"
              onChange={(event) => {
                setStartDate(event.target.value);
              }}
            />
            <input
              type="text"
              id="to"
              name="to"
              placeholder="2021-01-31"
              onChange={(event) => {
                setEndDate(event.target.value);
              }}
            />
          </div>
          <div className="input">
            <span>대학교</span>
            <input
              type="text"
              value={searchCollege}
              onChange={(dom) => {
                setSearchCollege(dom.target.value);
              }}
            />
          </div>
          <div className="input">
            <span>이름</span>
            <input
              type="text"
              value={searchName}
              onChange={(dom) => {
                setSearchName(dom.target.value);
              }}
            />
          </div>
          <div className="input">
            <span>학과</span>
            <input
              type="text"
              value={searchDept}
              onChange={(dom) => {
                setSearchDept(dom.target.value);
              }}
            />
          </div>
          <button
            type="button"
            onClick={() => {
              onSearch = true;
              getGroupBuyingList();
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
            </svg>
          </button>
        </div>
      </div>
    );
  }

  // 공동구매 리스트 출력
  function createGroupBuyingList() {
    return (
      <div className="table">
        <ul className="row title">
          <li className="order-id">주문번호</li>
          <li className="user-name">주문자</li>
          <li className="flex-10">대학교</li>
          <li className="flex-10">학과</li>
          <li className="counter">학년</li>
          <li className="day">주문일</li>
          <li className="price">최종금액</li>
          <li className="day">승인완료일</li>
        </ul>
        {groupBuyingRow}
      </div>
    );
  }

  // 아이템 클릭 시 상새내용 조회
  const onClickItem = (id: any) => {
    routeProps.history.push({
      pathname: `/admin/sale/group-buying-update/${id}`,
    });
  };

  // 최종금액 계산
  function totalAmountCount(books: any) {
    amountResult = 0;
    if (books.length === 0) {
      return amountResult;
    }
    if (books.length === 1) {
      amountResult = books[0].totalAmount;
    }
    if (books.length === 2) {
      amountResult = books[0].totalAmount + books[1].totalAmount;
    }
    if (books.length === 3) {
      amountResult = books[0].totalAmount + books[1].totalAmount + books[2].totalAmount;
    }
    return amountResult;
  }

  // 데이터값 불러오기
  const groupBuyingRow = items?.map((item: any) => (
    <ul
      className="row"
      key={item.id}
      onClick={() => {
        // setOrderNum(item.orderCode);
        onClickItem(item.orderCode);
      }}
    >
      <li className="order-id">{item.orderCode}</li>
      <li className="user-name">{item.userName}</li>
      <li className="flex-10">{item.college}</li>
      <li className="flex-10">{item.dept}</li>
      <li className="counter">{item.grader}</li>
      <li className="day">{new Date(item.orderDate).toLocaleDateString()}</li>
      <li className="price">{totalAmountCount(item.books).toLocaleString()}</li>
      <li className="day">{new Date(item.approvalDate).toLocaleDateString()}</li>
    </ul>
  ));

  // 테이블 하단 버튼 (미사용)
  const onClick = () => {};

  // AdminGroupBuying 리턴값
  return (
    <main className="list-group-buying wrapper">
      <div className="title">
        <h1>공동구매 현황</h1>
      </div>
      <div className="content">
        {createTableHeader()}
        {createGroupBuyingList()}
        {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => setCurrentPage(page),
          '',
          onClick,
          false
        )}
      </div>
    </main>
  );
}
